var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[(_vm.type=='url')?_c('div',{staticClass:"text--center color--black60 show--bigScreens"},[(_vm.text)?_c('div',[_vm._v("有")]):_c('div',[_vm._v("無")])]):_c('div',{staticClass:"text--center color--black60 show--bigScreens"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }